import { useEffect } from "react";
import { useLocation } from "react-router-dom";


export function ScrollToTop() {
    const {pathname} = useLocation()

    useEffect(() => {
        window.scrollTo(0, 0);
        },
        [pathname]
    );
    
    return null
}


export async function calcReadingTime(markdownFile) {
    // let str = fetch(markdownFile).then((response) => response.text()).then((md) => {return md.result});
    const response = await fetch(markdownFile);
    const markdownString = await response.text();

    // Use regex to remove any leading or trailing white space
    const str = markdownString.trim();
    
    // Use regex to split the string by spaces or punctuation
    let numWords = str.split(/[\s.,;!?]+/).length;
    const readingTime = numWords / 250;
    // Return the length of the resulting array
    return Math.ceil(readingTime);
  }

export function isImage(str){
    return /\.(jpg|jpeg|png|gif|bmp)$/i.test(str);
}

export function isVideo(str){
    return /\.(mpg|mp2|mpeg|mpe|mpv|mov|mp4)$/i.test(str);

}


export function smoothScrollToTop(duration) {
    const startPosition = window.pageYOffset;
    const startTime = performance.now();
  
    function scrollToTop(currentTime) {
      const elapsedTime = currentTime - startTime;
      const scrollDuration = Math.min(duration, elapsedTime);
      window.scrollTo(0, easeInOutQuad(scrollDuration, startPosition, -startPosition, duration));
  
      if (elapsedTime < duration) {
        requestAnimationFrame(scrollToTop);
      }
    }
  
    function easeInOutQuad(t, b, c, d) {
      t /= d / 2;
      if (t < 1) return c / 2 * t * t + b;
      t--;
      return -c / 2 * (t * (t - 2) - 1) + b;
    }
  
    requestAnimationFrame(scrollToTop);
  }